////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { isNull, isUndefined } from 'lodash'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
///////COMPONENTS///////
import ArticleDatePicker from '../ArticleDatePicker'
import { articleLifeManagerActionCreators } from '../../../../../store/actions'

/////////STYLED/////////
const AddStopWithRestockWrapper = styled.div``
/////////STYLED/////////
//[88]_e): ADD DATE STOP RESTOCK

const AddStopWithRestock = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateLimit, setDateToModify] = useState('')

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		let testDateToModify = ''
		if (!isNull(dateLimit) || !isUndefined(dateLimit)) {
			testDateToModify = dateLimit.toString().split(' ').splice(0, 4)
		}
		//(!isNull(dateLimit) || !isUndefined(dateLimit)) ? dateLimit.toString().split(' ').splice(0, 4) : null
		let testCurrentDate = moment().toDate().toString().split(' ').splice(0, 4)
		if (testDateToModify.join('') === testCurrentDate.join('')) {
			actionsArticleLifeManager.postAddStopWithRestock(match.params.id, 'addStopWithRestockAction', moment().add(5, 'minutes').toDate())
		} else {
			actionsArticleLifeManager.postAddStopWithRestock(match.params.id, 'addStopWithRestockAction', dateLimit)
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (props.addStopWithRestockAction.show) {
			if (isNull(props.addStopWithRestockAction?.item?.dateScheduledDeactivation)) {
				handleChangeDate(new Date())
			} else {
				setDateToModify(props.editStopWithRestockAction?.item?.dateScheduledDeactivation)
				handleChangeDate(moment(props.addStopWithRestockAction?.item?.dateScheduledDeactivation).toDate())
			}
		}
	}, [props.addStopWithRestockAction.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.addStopWithRestockAction.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<AddStopWithRestockWrapper>
			<ArticleDatePicker
				showModal={props.addStopWithRestockAction.show}
				date={dateLimit}
				handleValidate={handleValidate}
				handleClose={props.addStopWithRestockAction.close}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_restock_startDate_edit_title']}
				priorLimit={new Date(props.addStopWithRestockAction?.item?.dateScheduledDeactivation)}
			/>
		</AddStopWithRestockWrapper>
	)
}

AddStopWithRestock.propTypes = {}

AddStopWithRestock.defaultPropTypes = {}

export default AddStopWithRestock
